const ABProcessElementCore = require("../../../core/process/tasks/ABProcessElementCore");
module.exports = class ABProcessElement extends ABProcessElementCore {};
